<div class="kz-plan3D-fs--header">
  <strong class="kz-plan3D-fs--header-title">
    <ng-container i18n="@@kazaplan.popin.sidebar.medias.title">Media</ng-container>&nbsp;<small *ngIf="(kps.nbPlanMedias | async)">({{kps.nbPlanMedias | async}})</small></strong>
  <div class="kz-plan3D-fs--medias-filters">
    <ng-container *appNgLet="(kps.planMediasFilter | async) as planMediaFilter">
      <button [ngClass]="{'active-filter' : !planMediaFilter.mediaFilter }" (click)="filterMedias()"><kz-icons name="dice"></kz-icons></button>
      <button [ngClass]="{'active-filter' : planMediaFilter.mediaFilter == ('' + kazaplanMediasTypes.CAPTURE_HD)}"
              (click)="filterMedias(kazaplanMediasTypes.CAPTURE_HD)">HD</button>
      <button [ngClass]="{'active-filter' : planMediaFilter.mediaFilter == ('' + kazaplanMediasTypes.CAPTURE_360)}"
              (click)="filterMedias(kazaplanMediasTypes.CAPTURE_360)">360&deg;</button>
      <button [ngClass]="{'active-filter' : planMediaFilter.mediaFilter == ('' + kazaplanMediasTypes.CAPTURE_2D)}"
              (click)="filterMedias(kazaplanMediasTypes.CAPTURE_2D)">2D</button>
      <button [ngClass]="{'active-filter' : planMediaFilter.mediaFilter == ('' + kazaplanMediasTypes.CAPTURE_3D)}"
              (click)="filterMedias(kazaplanMediasTypes.CAPTURE_3D)">3D</button>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="(browserIsValid$ | async)">
  <div class="kz-plan3D-fs--medias-viewer" *ngIf="(kps.getCurrentKazaplan() | async)">
    <span
      (click)="kps.displayCurrentKazaplan = true"
      kzButton buttonContext="white">
        <span><kz-icons name="discover"></kz-icons>
            <span i18n="@@kazaplan.popin.sidebar.medias.cta.showPlan">View the plan</span>
        </span>
    </span>
  </div>
</ng-container>

<ul class="kz-plan3D-fs--medias-list"
    infinite-scroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    (scrolled)="onScroll()">
  <li [ngClass]="{'kz-current' : (i == (kps.getKazaplanCurrentMedia() | async))}"
      *ngFor="let planMedia of (kps.planMedias | async); let i = index; trackBy: trackMedia;"
      (click)="kps.kazaplanCurrentMedia = i">
    <img
      [src]="planMedia.fileUrl + '?width=173&height=108&fit=crop&quality=100'"
      [alt]="''"
      border="0">
  </li>
</ul>
<span
  class="kz-plan3D-fs--medias-list-empty"
  i18n="@@kazaplan.popin.sidebar.medias.emptyResult"
  [@fadeInAnimation]="{ value : (kps.planMedias | async) && !(kps.nbPlanMedias | async) ? ':enter' : ':leave', params : {time : '200ms', delay : '50ms', timeLeave : '0ms', delayLeave : '0ms' }}"
  *ngIf="(kps.planMedias | async) && !(kps.nbPlanMedias | async)"
  >No media</span>
<ng-container *ngIf="(browserIsValid$ | async)">
  <ng-container *ngIf="(kps.getModeLight() | async) == false">
    <div class="kz-plan3D-fs--medias-edit"
         *ngIf="(kps.getCurrentKazaplan() | async) && ((kps.isOwner() | async) || (userStoreService.isAdminStore | async))">
      <a
        [routerLink]="['/kazaplan', (kps.getCurrentKazaplan() | async).id, 'edit'] | localize"
        kzButton buttonContext="tools"><span><kz-icons name="pen"></kz-icons><span
        i18n="@@kazaplan.popin.sidebar.medias.cta.updatePlan">Edit the plan</span></span></a>
    </div>
  </ng-container>
</ng-container>
